import React, { Fragment, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';

import { productPropTypes } from 'helpers/propTypes';
import { getCookie, setCookie } from 'helpers/cookies';
import { formatCurrencyARS } from 'helpers/currency';
// import { setVisitsProducts } from 'services/user.services';

import DescriptionItem from 'components/commons/DescriptionItem';
import QuantitySelector from 'components/commons/QuantitySelector';
import ShippingQuote from 'components/commons/ShippingQuote';
import BestPriceDisplay from 'components/commons/BestPriceDisplay';
import DiscountBanner from 'components/commons/DiscountBanner';

import './Product.scss';

const Product = (props) => {
  const {
    images, item, onProductClick, onProductCopyClick, onQuantityChange,
    singleProductFullUrl, cartItemDescriptions, colors, combinations, wholesale,
    setWholesale, productCart, productCartSub, cartItemSubDescriptions, handleColorSelect,
    talles, combinationsTalle, selectedColor, getValidPriceRange, show,
    onClose, getSingleQuoteAction, singleQuote, zipCode, singleQuoteLoading,
    cuotasMP, onOpenPaymentModal, showMPButton, showShippingQuote = false,
    autoDiscounts, paymentMethods, isSinglePage = false
  } = props;

  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isZoomOpen, setIsZoomOpen] = useState(false);
  const productImages = Array.isArray(images) ? images.filter(Boolean) : [];
  const activeImage = productImages[activeImageIndex] || productImages[0];

  useEffect(() => {
    setActiveImageIndex(0);
    setIsZoomOpen(false);
  }, [images, selectedColor]);

  useEffect(() => {
    if (!isZoomOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsZoomOpen(false);
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isZoomOpen]);

  const hasInstallments = cuotasMP && cuotasMP.length > 0;
  const quantity = productCart ? productCart.quantity : (productCartSub?.quantity || 0);
  const findProductWholesale = (id) => {
    const product = item.product_wholesaler.find((prod) => prod.id === id);
    return product.price * product.quantity;
  };
  const otherProducts = cartItemDescriptions.filter((data) => (data.wholesale?.id !== wholesale.id));
  const hasNonNullPrice = talles.some(talle => talle.price !== null && talle?.price > 0);

  let hasColorOption = false;

  const hasValidQuantities = () => {
    const descriptionsValid = cartItemDescriptions.some(item => item.quantity > 0 && !item.wholesale.bool && (!hasColorOption || selectedColor !== null));
    const subDescriptionsValid = cartItemSubDescriptions.some(item => item.quantity > 0 && !item.wholesale.bool && (!hasColorOption || selectedColor !== null));

    if (wholesale.bool) {
      const descriptionsValid = cartItemDescriptions.some(item => item.quantity > 0 && item.wholesale.quantity === wholesale.quantity && (!hasColorOption || selectedColor !== null));
      const subDescriptionsValid = cartItemSubDescriptions.some(item => item.quantity > 0 && item.wholesale.quantity === wholesale.quantity && (!hasColorOption || selectedColor !== null));
      const suma = cartItemDescriptions.reduce((sum, item) => {
        if (item.wholesale.quantity === wholesale.quantity) {
          sum += item.quantity;
        }
        return sum;
      }, 0);
      return (descriptionsValid || subDescriptionsValid) && suma % wholesale.quantity === 0 && suma > 0;
    }

    if (cartItemSubDescriptions.length === 0 && cartItemDescriptions.length === 0) {
      return true;
    }
    return descriptionsValid || subDescriptionsValid;
  };

  useEffect(() => {
    if (selectedColor === null && hasColorOption) {
      const firstColorId = Object.keys(combinations)[0];
      const firstColor = colors.find(
        ({ stock_description_id }) => stock_description_id === Number(firstColorId)
      );

      if (firstColor) {
        handleColorSelect(firstColor);
      }
    }
  }, [selectedColor, hasColorOption, combinations, colors, handleColorSelect]);

  const addProduct = async (arrCount) => {
    const existProduct = arrCount.includes(item.id);
    if (!existProduct) {
      arrCount.push(item.id);
      setCookie('visit_product', arrCount, { maxAge: 86400 });
      const data = {
        id: item.id,
      };
      // await setVisitsProducts(data);
    }
  };

  const updateCookie = async () => {
    try {
      if (getCookie('visit_product')) {
        const arrCount = getCookie('visit_product');
        addProduct(arrCount);
      } else {
        const arrCount = [];
        addProduct(arrCount);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    updateCookie();
  });

  const renderProductQuantitySelector = () => {
    if (item.stock_product_descriptions.length > 0) {
      // Some catalogs track only sizes (without a color category). The previous
      // branch rendered an empty color list in that case, leaving no way to set qty.
      if (colors.length === 0 && talles.length > 0) {
        return (
          <>
            <div className="product-details-stock-title">Elegí talle y cantidad</div>
            <ul className="product-details-stock product-details-stock-description product-modal__size-quantities">
              {talles.filter((description) => description.stock > 0).map((description) => (
                <li key={`${item.id}-${description.id}-${wholesale.id}`}>
                  <DescriptionItem
                    description={description}
                    onQuantityChange={onQuantityChange}
                    showQuantitySelector
                    showColors={false}
                    show={show}
                    storage={cartItemDescriptions.find((data) => (
                      data.descriptionId === description.id && data.wholesale.id === wholesale.id
                    ))}
                    storageSub={cartItemSubDescriptions.find((data) => (
                      data.descriptionId === description.id && data.wholesale.id === wholesale.id
                    ))}
                    othersWholesale={cartItemDescriptions.filter((data) => (
                      data.descriptionId === description.id && data.wholesale.id !== wholesale.id
                    ))}
                    othersWholesaleSub={cartItemSubDescriptions.filter((data) => (
                      data.descriptionId === description.id && data.wholesale.id !== wholesale.id
                    ))}
                  />
                </li>
              ))}
            </ul>
          </>
        );
      }

      if (colors.length === 0 && item.stock > 0) {
        return (
          <>
            <div className="product-modal__quantity-label">{isSinglePage ? 'Elegí la cantidad' : 'Cantidad'}</div>
            <QuantitySelector
              limit={item.stock}
              onQuantityChange={onQuantityChange}
              quantity={quantity}
              quantityOthersWholesale={otherProducts.map((otherProduct) => otherProduct.quantity)}
              show={show}
            />
          </>
        );
      }

      { hasColorOption = true }
      return (
        <>
          <div className="product-details-stock-title">Seleccione un color</div>
          <ul className="product-details-stock">
            {Object.keys(combinations).map((id) => {
              const color = colors.find(
                ({ stock_description_id }) => stock_description_id === Number(id),
              );
              const descriptions = combinations[id];
              const isSelected = selectedColor === Number(id);
              return (
                <div className={`product-details-stock-option ${isSelected ? "product-selected" : ""}`} key={`${item.id}-${id}-${wholesale.id}`}>
                  <DescriptionItem
                    description={color}
                    handleColorSelect={handleColorSelect}
                    onQuantityChange={onQuantityChange}
                    showQuantitySelector={descriptions.length === 0}
                    storage={cartItemDescriptions.find(
                      (data) => (
                        data.descriptionId === color.id && data.wholesale.id === wholesale.id
                      ),
                    )}
                    storageSub={cartItemSubDescriptions.find(
                      (data) => (
                        data.descriptionId === color.id && data.wholesale.id === wholesale.id
                      ),
                    )}
                    othersWholesale={cartItemDescriptions.filter(
                      (data) => (
                        data.descriptionId === color.id && data.wholesale.id !== wholesale.id
                      ),
                    )}
                    othersWholesaleSub={cartItemSubDescriptions.filter(
                      (data) => (
                        data.descriptionId === color.id && data.wholesale.id !== wholesale.id
                      ),
                    )}
                    show={show}
                  />
                </div>
              );
            })}
          </ul>
          {!hasValidQuantities() && selectedColor !== null && (
            <div>
              {!wholesale.bool ? (
                <div className='product-invalid-quantity'>
                  Ingrese la cantidad deseada antes de agregar el producto al carrito.
                </div>
              ) : (
                <div className='product-invalid-quantity'>
                  Ingrese la cantidad adecuada antes de agregar el producto al carrito.
                </div>
              )}
            </div>
          )}

          {(selectedColor !== null && (
            <ul className='product-details-stock-option product-details-stock-description'>
              {combinations[selectedColor].map((description) => {
                return (
                  <Fragment key={`${item.id}-${description.id}-${wholesale.id}`}>
                    {(
                      (description.stock > 0 && !wholesale.bool)
                      || (description.stock >= wholesale.quantity && wholesale.bool)
                    ) && (
                        <li className="float-xs-left" key={`${item.id}-${description.id}-${wholesale.id}`}>
                          <DescriptionItem
                            description={description}
                            onQuantityChange={onQuantityChange}
                            showQuantitySelector={true}
                            showColors={true}
                            storage={cartItemDescriptions.find(
                              (data) => (
                                data.descriptionId === description.id &&
                                data.wholesale.id === wholesale.id
                              ),
                            )}
                            storageSub={cartItemSubDescriptions.find(
                              (data) => (
                                data.descriptionId === description.id &&
                                data.wholesale.id === wholesale.id
                              ),
                            )}
                            othersWholesale={cartItemDescriptions.filter(
                              (data) => (
                                data.descriptionId === description.id &&
                                data.wholesale.id !== wholesale.id
                              ),
                            )}
                            othersWholesaleSub={cartItemSubDescriptions.filter(
                              (data) => (
                                data.descriptionId === description.id &&
                                data.wholesale.id !== wholesale.id
                              ),
                            )}
                            show={show}
                          />
                        </li>
                      )}
                  </Fragment>
                )
              }
              )}
            </ul>
          ))}
        </>
      );
    }
    if (item.stock > 0) {
      return (
        <>
          <div className="product-modal__quantity-label">{isSinglePage ? 'Elegí la cantidad' : 'Cantidad'}</div>
          <QuantitySelector
            limit={item.stock}
            onQuantityChange={onQuantityChange}
            quantity={quantity}
            quantityOthersWholesale={otherProducts.map((otherProduct) => (otherProduct.quantity))}
            show={show}
          />
        </>
      );
    }

    return <span className="product-details-out-of-stock">Sin stock</span>;
  };

  const renderButton = () => {
    return (

      <div className="products-add-cart">
        <button className="products-add-cart-button" onClick={onClose}>
          Agregar al carrito<i className="fa fa-shopping-cart products-add-cart-icon" />
        </button>
      </div>
    );
  };


  return (
    <>
    <div data-testid="product-modal" className="product-modal product-modal--modern">
      <div className="product-modal__layout">
        <section className="product-modal__gallery" aria-label={'Im\u00e1genes del producto'}>
          <div className="product-modal__image-container">
            {productImages.length > 0 ? (
              <>
                <div className="product-modal__gallery-frame">
                  <button className="product-modal__image-zoom-trigger" type="button" onClick={() => setIsZoomOpen(true)} aria-label="Ampliar imagen del producto">
                    <img className="product-modal__image" alt={item.name} src={activeImage} />
                  </button>
                  {productImages.length > 1 && (
                    <>
                      <button className="product-modal__gallery-arrow is-previous" type="button" aria-label="Ver foto anterior" onClick={() => setActiveImageIndex((index) => (index - 1 + productImages.length) % productImages.length)}><i className="fa fa-angle-left" aria-hidden="true" /></button>
                      <button className="product-modal__gallery-arrow is-next" type="button" aria-label="Ver foto siguiente" onClick={() => setActiveImageIndex((index) => (index + 1) % productImages.length)}><i className="fa fa-angle-right" aria-hidden="true" /></button>
                    </>
                  )}
                </div>
                {productImages.length > 1 && (
                  <div className="product-modal__thumbnails" aria-label="Elegir foto del producto">
                    {productImages.map((image, index) => (
                      <button className={`product-modal__thumbnail${index === activeImageIndex ? ' is-active' : ''}`} key={`product-thumbnail-${index}-${image}`} type="button" aria-label={`Ver foto ${index + 1}`} aria-pressed={index === activeImageIndex} onClick={() => setActiveImageIndex(index)}>
                        <img alt="" src={image} />
                      </button>
                    ))}
                  </div>
                )}
              </>
            ) : <div className="product-modal__empty-image" aria-hidden="true">{item.name}</div>}
          </div>
        </section>
        <section className="product-modal__details" aria-label="Detalle del producto">
          <header className="product-modal__heading">
            <h1 className="product-details-name" onClick={onProductClick} role="presentation">{item.name}</h1>
            <CopyToClipboard text={singleProductFullUrl} onCopy={onProductCopyClick}>
              <button type="button" className="product-details-copy-icon" aria-label="Copiar link del producto" title="Copiar link del producto"><i className="fa fa-clone" aria-hidden="true" /></button>
            </CopyToClipboard>
          </header>
          {item.product_wholesaler.length > 0 && (
            <div className="container-mayorista product-modal__wholesale" aria-label="Opciones de precio">
              <button onClick={() => setWholesale({ id: 0, bool: false, quantity: 0, curva: false })} className={!wholesale.bool ? 'circular-button-selected circular-button' : 'circular-button'} type="button"><span className="button-text">{'Precio est\u00e1ndar'}</span></button>
              {item.product_wholesaler.map((prod) => (
                <button key={prod.id} onClick={() => setWholesale({ id: prod.id, bool: true, quantity: prod.quantity, curva: prod.curva })} className={(wholesale.bool && wholesale.id === prod.id) ? 'circular-button-selected circular-button' : 'circular-button'} type="button"><span className="button-text">{prod.comboName ?? `Precio por ${prod.quantity}`}</span></button>
              ))}
            </div>
          )}
          {!wholesale.bool && item.sale ? <div className="product-discount-tag">{`${Math.round(100 - (item.sale / item.price) * 100)}% OFF`}</div> : null}
          <div className="product-modal__price">
            {item.product_wholesaler.length > 0 ? (
              <div className="product-details-price">{wholesale.bool ? show && formatCurrencyARS(findProductWholesale(wholesale.id)) : show && formatCurrencyARS(item.price)}</div>
            ) : (
              <div className="product-details-price">
                {!hasNonNullPrice ? (item.sale > 0 ? <><div className="price">{formatCurrencyARS(item.sale)}</div><span className="discount">{show && formatCurrencyARS(item.price)}</span></> : <div className="price">{show && formatCurrencyARS(item.price)}</div>) : <div className="price">{show && getValidPriceRange()}</div>}
              </div>
            )}
          </div>
          <DiscountBanner autoDiscounts={autoDiscounts} paymentMethods={paymentMethods} />
          {item.description && <div className="product-details-section product-modal__description"><span className="product-details-description">{item.description}</span></div>}
          <div className="product-modal__purchase">
            <div className="product-modal__quantity">{renderProductQuantitySelector()}</div>
            {showShippingQuote && <div className="product-modal__shipping">{'Env\u00edos a todo el pa\u00eds'}</div>}
            {renderButton()}
            {hasInstallments && showMPButton && <button type="button" className="pt-payment-methods-link product-installments-link" onClick={onOpenPaymentModal}>{'Ver bancos con cuotas sin inter\u00e9s'}</button>}
          </div>
        </section>
      </div>
    </div>
    {isZoomOpen && activeImage && createPortal(
      <div className="product-image-zoom" role="dialog" aria-modal="true" aria-label={`Imagen ampliada: ${item.name}`} onClick={() => setIsZoomOpen(false)}>
        <button className="product-image-zoom__close" type="button" aria-label="Cerrar imagen ampliada" onClick={() => setIsZoomOpen(false)}>×</button>
        <img className="product-image-zoom__image" src={activeImage} alt={item.name} onClick={(event) => event.stopPropagation()} />
      </div>,
      document.body,
    )}
    </>
  );
};

Product.defaultProps = {
  combinations: {},
  handleColorSelect: () => { },
  productCart: null,
  productCartSub: null,
  isSinglePage: false,
};

Product.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  combinations: PropTypes.shape(),
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  cartItemDescriptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  cartItemSubDescriptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleColorSelect: PropTypes.func,
  item: productPropTypes.isRequired,
  isSinglePage: PropTypes.bool,
  onProductClick: PropTypes.func.isRequired,
  onProductCopyClick: PropTypes.func.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  singleProductFullUrl: PropTypes.string.isRequired,
  wholesale: PropTypes.shape().isRequired,
  setWholesale: PropTypes.func.isRequired,
  productCart: PropTypes.shape({
    quantity: PropTypes.number,
  }),
  productCartSub: PropTypes.shape({
    quantity: PropTypes.number,
  }),
  onClose: PropTypes.func.isRequired,
  selectedColor: PropTypes.number,
  showShippingQuote: PropTypes.bool,
};

export default Product;
